var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("登錄發票列表")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-1 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 登錄發票列表 ")]), _c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.exportInvoiceLog();
      }
    }
  }, [_vm._v("匯出")]), _c('b-form-select', {
    attrs: {
      "options": _vm.types
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "type", $$v);
      },
      expression: "query.type"
    }
  }), _c('b-form-select', {
    staticClass: "ml-2",
    attrs: {
      "options": _vm.statuses
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  }), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋發票號碼、會員名稱、手機、外部編碼"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.invoiceLogs,
      "fields": _vm.fields,
      "busy": _vm.showLoading
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(image)",
      fn: function fn(data) {
        return [data.item.image ? _c('b-img', {
          staticStyle: {
            "max-width": "100px",
            "max-height": "100px",
            "cursor": "pointer"
          },
          attrs: {
            "src": data.item.image.url,
            "fluid": "",
            "thumbnail": ""
          },
          on: {
            "click": function click($event) {
              return _vm.showImage(data.item.image.url);
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(type)",
      fn: function fn(data) {
        return [data.item.type == _vm.consts.INVOICE_LOG_TYPES.TRADITIONAL ? _c('div', [_vm._v("傳統發票")]) : data.item.type == _vm.consts.INVOICE_LOG_TYPES.ELECTRONIC && data.item.random ? _c('div', [_vm._v("電子發票")]) : _c('div', [_vm._v("載具發票")])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_vm.$permissions.has(_vm.$permissions.consts.INVOICE_LOG_VERIFY) ? _c('b-button', {
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'InvoiceLogVerify',
              params: {
                invoiceLogId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-check-circle-outline mr-1"
        }), _vm._v("審核 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.INVOICE_LOG_MODIFY) ? _c('b-button', {
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'InvoiceLogView',
              params: {
                invoiceLogId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v("查看 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.INVOICE_LOG_MODIFY) ? _c('b-button', {
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'InvoiceLogEdit',
              params: {
                invoiceLogId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("編輯 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.INVOICE_LOG_DELETE) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item.id);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v("刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }